import type { MyParentCompanyData } from "~admin/parent-company/helpers/parentCompanyAccess";

import { useMyParentCompanyQuery } from "~/services/endpoints/apiEndpoints";

export interface UseMyParentCompanyReturn {
	isError: boolean;
	isLoading: boolean;
	parentCompany: MyParentCompanyData | null;
	refetch: () => void;
}

const useMyParentCompany = (): UseMyParentCompanyReturn => {
	const { data, isError, isLoading, refetch } = useMyParentCompanyQuery();
	return { isError, isLoading, parentCompany: data?.myParentCompany ?? null, refetch };
};

export default useMyParentCompany;
